export const environment = {
  production: true,
  base1: 'https://cealm.gotasoft.com/public/api/',
  base5: 'http://127.0.0.1:8000/api/',
  base4: 'http://54.85.52.2/sistemas/cealm/servidor/public/api/',
  base6: 'https://3.125.150.36/cealm/servidor/public/api/',
  base: 'https://cealm.edu.bo/cealm/servidor/public/api/'
};
